"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyChoiceModal = void 0;
const React = __importStar(require("react"));
const merlin_info_panels_1 = require("@travelnest/merlin.info-panels");
const Modal_1 = require("../modal/Modal");
const Button_1 = require("../button/Button");
const Paragraph_1 = require("../paragraph/Paragraph");
const merlin_select_1 = require("@travelnest/merlin.select");
const Spacer_1 = require("../spacer/Spacer");
const helpers_1 = require("../../../entities/pricing/helpers");
const CurrencyChoiceModal = ({ isOpen, onClose, onCurrencyChosen }) => {
    // Default to GBP so single tap required for majority of customers
    const [selectedCurrency, setSelectedCurrency] = React.useState('');
    const currencySelectHandler = (e) => {
        const selection = e.target.value;
        setSelectedCurrency(helpers_1.CurrencyCodes[selection] || '');
    };
    const continueButtonTapHandler = () => {
        if (selectedCurrency !== '') {
            onCurrencyChosen(selectedCurrency);
            onClose(true);
        }
    };
    const CancelButton = React.createElement(Button_1.Button, { onClick: () => onClose(false) }, "Go back");
    const ContinueButton = React.createElement(Button_1.Button, { disabled: selectedCurrency === '', buttonType: Button_1.PresetThemes.Primary, onClick: continueButtonTapHandler }, "I'm happy, continue");
    return isOpen ? (React.createElement(Modal_1.Modal, { title: "Set property currency", onRequestClose: () => onClose(false), actionLHS: CancelButton, actionRHS: ContinueButton },
        React.createElement(Paragraph_1.Paragraph, null, "We need to set the currency you want to use for this property. Once you set it, it cannot be changed."),
        React.createElement(Spacer_1.Spacer, { spacing: "small" }),
        React.createElement(Paragraph_1.Paragraph, null, "This will apply to your nightly pricing, along with any fees you specify."),
        React.createElement(Spacer_1.Spacer, { spacing: "large" }),
        React.createElement(merlin_select_1.Select, { label: "Currency", id: "currency-select", onChange: currencySelectHandler, value: selectedCurrency || '' },
            React.createElement("option", { value: "" }, "Select currency"),
            Object.keys(helpers_1.CurrencyCodes).map((c) => React.createElement("option", { key: helpers_1.CurrencyInfo[c].code, value: helpers_1.CurrencyInfo[c].code },
                helpers_1.CurrencyInfo[c].symbol,
                " ",
                c))),
        React.createElement(Spacer_1.Spacer, null),
        React.createElement(merlin_info_panels_1.DidYouKnow, { text: "On booking sites, guests will see the price in their own currency.", colour: 'yellow', id: 'price-currency' })))
        :
            null;
};
exports.CurrencyChoiceModal = CurrencyChoiceModal;
//# sourceMappingURL=CurrencyChoiceModal.js.map